const BaseModule = require('../../90_utils/base/BaseModule');

class TopSuperMenu extends BaseModule {

	constructor(el, params) {

		super(el);

		this.isSiteLoaded = false;
	}

	// private methods

	_domReady(){

	}

	_addListeners(){

		this.$el.on('open', $.proxy(this._onOpenTrigger, this));
		this.$el.on('close', $.proxy(this._onCloseTrigger, this));
		this.$el.find('a').on('click', $.proxy(this._onNavItemClick, this));

		window.vent.on('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.on('pageChangeStart', this._onPageChangeStart, this);
	}

	_removeListeners(){

		this.$el.off('open', $.proxy(this._onOpenTrigger.bind, this));
		this.$el.off('close', $.proxy(this._onCloseTrigger.bind, this));
		this.$el.find('a').off('click', $.proxy(this._onNavItemClick, this));

		window.vent.off('siteLoadComplete', this._onSiteLoadComplete, this);
		window.vent.off('pageChangeStart', this._onPageChangeStart, this);
	}

	// element event listeners

	_onOpenTrigger(){
		this.open();
	}

	_onCloseTrigger(){
		this.close();
	}

	_onNavItemClick(e){
		let $target = $(e.currentTarget);
		if(typeof($target.attr('target')) === 'undefined' && $target.attr('href') !== 'javascript:;'){
			this.close();
		}
	}

	_onPageChangeStart(){
		this._updateSelectedLinks();
	}

	_onSiteLoadComplete(){
		this.isSiteLoaded = true;
		this._updateSelectedLinks();
	}

	//

	_updateSelectedLinks(){

		let $el = $('.top-super-menu'); // gets moved around from modaal, but somehow listeners work
		let routeObj = window.SETTINGS.router.getRouteObj();

		let $page = $el.find(`[data-page-id="${routeObj.pageId}"]`);
		let $section = $el.find(`[data-section-id="${routeObj.sectionId}"]`);

		if($page.length){
			$el.find('[data-page-id]').removeClass('is-active');
			$page.addClass('is-active');
		}

		if($section.length){
			$el.find('[data-section-id]').removeClass('is-active');
			// $section.addClass('is-active');
		}
	}

	//

	open(){

		if(!this.$el.hasClass('is-open')){
			this.$el.addClass('is-open');
		}
	}

	close(){

		if(this.$el.hasClass('is-open')){
			this.$el.removeClass('is-open');
		}

		$('#top-nav [data-modal-link="foo"]').eq(0).modaal('close');
	}

	//

	_show(){ }
	_hide(){ }

	_enable(){ }
	_disable(){ }

	_domUpdate(){ }
	_resize(){ }
}

module.exports = TopSuperMenu;
